import ApplicationController from '@/controllers/application_controller'
import {MoneyFormatter} from "@/controllers/models/money_formatter";

export default class extends ApplicationController {
  static values = {
    creditCost: Number,
    reach: { type: Number, default: 500 },
    multiplier: { type: Number, default: 1 },
    country: String,
  }

  static targets = ['amount', 'singleSmsAmount', 'singleSmsDiscountedAmount', 'disclaimer']

  initialize() {
    this.countryCurrency = JSON.parse(this.valueOfMetaTag('country_currency'))

    this.moneyFormatter = new MoneyFormatter(
      this.countryCurrency.code,
      {
        divide: false,
      }
    )

    this.moneyFormatterWithoutRounding = new MoneyFormatter(
      this.countryCurrency.code,
      {
        divide: false,
        round: false
      }
    )

    this.multiplierValue = this.countryCurrency.multiplier
    super.initialize()
  }

  updateReach({ currentTarget }) {
    this.reachValue = currentTarget.value
    this.calculateTotal()
  }

  updateCountry({ currentTarget }) {
    const currency = JSON.parse(currentTarget.dataset.currency)

    this.moneyFormatter = new MoneyFormatter(
      currency.code,
      {
        divide: false,
      }
    )

    this.moneyFormatterWithoutRounding = new MoneyFormatter(
      currency.code,
      {
        divide: false,
        round: false
      }
    )

    this.creditCostValue = currentTarget.dataset.smsCost
    this.multiplierValue = currency.multiplier
    this.countryValue = currentTarget.dataset.name

    this.countryCurrency = currency
    this.calculateTotal()
  }

  calculateTotal() {
    const totalAmount = this.creditCostValue * this.multiplierValue * this.reachValue * this.discountedCost

    this.amountTarget.innerHTML = t.static.pricing_v2.amount_per_month
      .replace('%{amount}', this.moneyFormatter.humanizeWithSymbolAndWithoutCurrencyCode(totalAmount))
      .replace('%{currency}', this.countryCurrency.code)

    this.singleSmsAmountTarget.innerText = this.moneyFormatterWithoutRounding.humanizeWithSymbol(
      this.multiplierValue * this.cost * this.creditCostValue,
    )

    this.singleSmsDiscountedAmountTarget.innerText = this.moneyFormatterWithoutRounding.humanizeWithSymbol(
      this.multiplierValue * this.discountedCost * this.creditCostValue,
    )

    this.disclaimerTarget.innerText = t.static.pricing_v2.bundle.footer.line1
      .replace(
        '%{amount_per_sms}',
        this.moneyFormatterWithoutRounding.humanizeWithSymbol(this.multiplierValue * this.cost * this.creditCostValue)
      )
      .replace('%{country}', this.countryValue)
  }

  get cost() {
    return 0.016
  }

  get discountedCost() {
    return 0.010
  }
}
